
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';

interface TrackDetailsInputProps {
  title: string;
  description: string;
  onTitleChange: (title: string) => void;
  onDescriptionChange: (description: string) => void;
}

const TrackDetailsInput: React.FC<TrackDetailsInputProps> = ({
  title,
  description,
  onTitleChange,
  onDescriptionChange
}) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="track-title">Track Title</Label>
        <Input
          id="track-title"
          type="text"
          placeholder="Enter track title..."
          value={title}
          onChange={(e) => onTitleChange(e.target.value)}
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="track-description">Description</Label>
        <Textarea
          id="track-description"
          placeholder="Describe the download your fans will receive when they like your song."
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          rows={3}
        />
      </div>
    </div>
  );
};

export default TrackDetailsInput;
